<template>
    <div class="app-not-found">
        <img src="/svg/404.svg" width="300px">
        <mu-title color="primary">Ocorreu um erro interno</mu-title>
        <p>Desculpe, mas a página que você tentou não pode ser visualizada.</p>
    </div>
</template>

<script>
    export default {
        name: 'app-error-500'
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .app-not-found
        text-align center
        padding 50px 0
        color $grey

</style>
